export const validationRules = {
    firstName: [(val) => !!val || "Vorname ist erforderlich"],
    lastName: [(val) => !!val || "Nachname ist erforderlich"],
    email: [
        (val) => !!val || "E-Mail ist erforderlich",
        (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val) || "Ungültige E-Mail-Adresse",
    ],
    phone: [
        (val) => !!val || "Telefonnummer ist erforderlich",
        (val) => /^0(?:[1-9]\d{1,4})?[\s/()-]*\d{6,15}$/.test(val) || "Die Telefonnummer muss mit einer 0 beginnen und darf nur Ziffern enthalten (mind. 6-stellig)",
    ],
    /*
    zipCode: [
        (val) => !!val || "PLZ ist erforderlich",
        (val) => /^[0-9]{5}$/.test(val) || "PLZ muss 5-stellig sein",
    ],
    houseNumber: [
        (val) => !!val || "Hausnummer ist erforderlich",
    ],
    city: [(val) => !!val || "Ort ist erforderlich"],
    street: [(val) => !!val || "Straße ist erforderlich"],
     */
    salutation: [(val) => !!val || "Bitte wählen Sie eine Anrede"],
    termsAccepted: [(val) => val === true || "Bitte akzeptieren Sie die Bedingungen"],
    "postalAddress.firstName": [(val) => !!val || "Vorname erforderlich"],
    "postalAddress.lastName": [(val) => !!val || "Nachname erforderlich"],
    "postalAddress.salutation": [(val) => !!val || "Anrede erforderlich"],
    "postalAddress.street": [(val) => !!val || "Straße erforderlich"],
    "postalAddress.houseNumber": [(val) => !!val || "Hausnummer erforderlich"],
    "postalAddress.zipCode": [
        (val) => !!val || "PLZ erforderlich",
        (val) => /^[0-9]{5}$/.test(val) || "PLZ muss 5 Ziffern enthalten",
    ],
    "postalAddress.city": [(val) => !!val || "Ort erforderlich"]
};
